import type { deTelephony } from './de.telephony';

export const trTelephony: Record<keyof typeof deTelephony, string> = {
  'campaign.tab.phone': 'Arama',

  'call.title': 'Ara',
  'call.manualNumber': 'Telefon numarası',
  'call.start': 'Ara',
  'call.hangup': 'Kapat',
  'call.mute': 'Sessize al',
  'call.unmute': 'Sesi aç',
  'call.continue': 'Aramaya devam et',
  'call.wrapUp': 'Sonucu kaydet',
  'call.state.idle': 'Hazır',
  'call.state.dialing': 'Bağlantı kuruluyor …',
  'call.state.ringing': 'Çalıyor …',
  'call.state.connected': 'Görüşmede',
  'call.state.reconnecting': 'Bağlantı kesildi – lütfen bekleyin',
  'call.state.ended': 'Görüşme bitti',
  'call.phoneUnavailable': 'Arama şu anda kullanılamıyor. Lütfen birazdan tekrar deneyin.',
  'call.providerProblem': 'Telefon sağlayıcısında bir sorun var. Lütfen yöneticinize başvurun.',
  'call.reconnected': 'Bağlantı yeniden kuruldu.',

  'sip.title': 'Telefon sağlayıcısı',
  'sip.hint': 'Bu bilgileri telefon sağlayıcınızdan alırsınız.',
  'sip.host': 'Sunucu',
  'sip.username': 'Kullanıcı adı',
  'sip.password': 'Parola',
  'sip.passwordStored': 'Parola kaydedildi',
  'sip.passwordKeep': 'Kayıtlı parolayı korumak için boş bırakın.',
  'sip.port': 'Port',
  'sip.transport': 'Aktarım',
  'sip.authId': 'Giriş adı',
  'sip.realm': 'Alan adı',
  'sip.mode': 'Erişim türü',
  'sip.mode.global': 'Tüm ekip için tek erişim',
  'sip.mode.individual': 'Her temsilci için ayrı erişim',
  'sip.test': 'Bağlantıyı test et',
  'sip.test.ok': 'Telefon sağlayıcısına bağlantı başarılı.',
  'sip.test.rejected': 'Telefon sağlayıcısına giriş başarısız. Lütfen kullanıcı adı ve parolayı kontrol edin.',
  'sip.test.unreachable': 'Telefon sağlayıcısına ulaşılamıyor.',
  'sip.notConfigured': 'Bu kampanya için henüz telefon sağlayıcısı tanımlanmadı.',
  'sip.forUser': 'Erişim sahibi',

  'error.sip.not_configured': 'Bu kampanya için henüz telefon sağlayıcısı tanımlanmadı.',
  'error.sip.not_configured_for_user': 'Bu kampanyada sizin için henüz telefon sağlayıcısı tanımlanmadı.',
  'error.sip.wrong_mode': 'Bu erişim türü kampanya ayarına uymuyor.',
  'error.sip.password_required': 'Lütfen telefon sağlayıcısının parolasını girin.',
  'error.sip.incomplete': 'Lütfen sunucu ve kullanıcı adını girin.',
  'error.call.not_found': 'Bu görüşme bulunamadı.',
  'error.call.not_ended': 'Görüşme hâlâ sürüyor.',
  'error.call.already_active': 'Zaten bir görüşmedesiniz.',
  'error.call.sales_result_required': 'Lütfen görüşmenin sonucunu kaydedin.',
  'error.call.required_fields_missing': 'Lütfen işaretli alanları doldurun.',
  'error.campaign.stopped': 'Bu kampanya durduruldu. Lütfen yöneticinize başvurun.',
  'error.campaign.calls_in_progress': 'Bu kampanyada görüşmeler sürüyor. Lütfen bitmelerini bekleyin.',
  'error.billing.insufficient_balance': 'Bakiyeniz bir görüşme daha için yetmiyor. Lütfen bakiye yükleyin.',
  'error.telephony.unavailable': 'Arama şu anda kullanılamıyor. Lütfen birazdan tekrar deneyin.',
  'error.telephony.failed': 'Arama kurulamadı.',
  'call.microphoneDenied':
    'Tarayıcı mikrofon erişimini reddetti. Lütfen bu sayfa için izin verin ve sayfayı yenileyin.',
  'call.microphoneMissing':
    'Bağlı mikrofon yok. Lütfen bir kulaklık bağlayın ve sayfayı yenileyin.',
  'call.microphoneBusy':
    'Mikrofonu şu anda başka bir program kullanıyor. Lütfen onu kapatın ve sayfayı yenileyin.',
  'call.microphoneUnavailable':
    'Bu tarayıcı burada mikrofona erişim veremiyor. Lütfen güncel bir Chrome veya Firefox kullanın.',
  'call.microphoneError':
    'Mikrofon açılamadı. Lütfen sayfayı yenileyin.',
};
